import {
  Text,
  IconPlus,
  IconClock,
  Button,
  SequenceMenu,
  useModalState,
  GreyGrey80,
  Box,
  Flex
} from '@sequencehq/core-components'
import { AiApiKeySettingsModal } from './AiApiKeySettingsModal'

interface ChatHeaderProps {
  onNewChat?: () => void
  chatHistory?: Array<{ id: string; title: string; timestamp: Date }>
  onSelectChat?: (chatId: string) => void
  chatTitle: string
  onDelete?: () => void
}

export const ChatHeader = ({
  onNewChat,
  chatTitle = 'New chat',
  onDelete
}: ChatHeaderProps) => {
  const {
    isModalOpen: isApiKeyModalOpen,
    openModal: onApiKeyModalOpen,
    closeModal: onApiKeyModalClose
  } = useModalState()

  // TODO: Implement a popover with chat history
  const openChatHistory = () => null

  return (
    <>
      <AiApiKeySettingsModal
        isOpen={isApiKeyModalOpen}
        onClose={onApiKeyModalClose}
      />
      <Box
        backgroundColor="white"
        height="48px"
        borderTopLeftRadius="8px"
        borderTopRightRadius="8px"
        borderBottom="1px solid"
        borderColor="#e4e8ef"
        width="100%"
        display="flex"
        alignItems="center"
        overflow="hidden"
        position="relative"
      >
        <Flex
          justify="space-between"
          align="center"
          width="100%"
          height="48px"
          px={4}
          py={2}
        >
          <Text
            fontSize="14px"
            fontWeight="bold"
            color="#344054"
            lineHeight="16px"
            whiteSpace="nowrap"
          >
            {chatTitle}
          </Text>

          <Flex gap="8px">
            <Button
              aria-label="New chat"
              onClick={onNewChat}
              variant="ghost"
              icon={<IconPlus color={GreyGrey80} />}
            />

            <Button
              aria-label="Chat history"
              onClick={openChatHistory}
              variant="ghost"
              icon={<IconClock color={GreyGrey80} />}
            />

            <SequenceMenu
              variant="ghost"
              data-testid="revrec.aiChat.header.menu"
              items={[
                {
                  label: 'API Settings',
                  onClick: onApiKeyModalOpen,
                  'data-testid': 'revrec.aiChat.header.menu.apiSettings'
                },
                {
                  label: 'Delete chat',
                  onClick: onDelete
                }
              ]}
            />
          </Flex>
        </Flex>
      </Box>
    </>
  )
}
